<template>
  <div 
    @contextmenu.prevent="null"
    style="display: flex; flex-direction: column; height: 100%; width: 100%; user-select: none; cursor: default;"
  >
    <v-data-table 
      :headers="display.CRMRealTimeEventsHeaders.sort((a, b) => a.index - b.index)" 
      :items="display.CRMRealTimeEvents" 
      :items-per-page="-1"
      :loading="loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent"
      loading-text=""
      fixed-header
      hover
      style="flex: 1; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;"
    >
      <template v-slot:headers="{ columns }">
        <tr>
          <th v-for="column in columns" :key="column.key">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 25px;">
              <template v-if="!loader.getSystemInformationData">
                <v-icon v-if="display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).index > 0" @click="updateCRMRealTimeEventsHeadersIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                <template v-if="column.key == 'CRMRealTimeEventSelectAction'">
                  <v-checkbox-btn 
                    v-model="input.allCRMRealTimeEventsSelected" 
                    @update:model-value="display.CRMRealTimeEvents.forEach(CRMRealTimeEvent => CRMRealTimeEvent.selectedCRMRealTimeEvent = input.allCRMRealTimeEventsSelected)"
                    color="indigo" 
                    density="compact" 
                    hide-details>
                  </v-checkbox-btn>
                </template>
                <template v-else>
                  <v-icon color="indigo" style="margin-right: 5px;">{{ display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).icon }}</v-icon>
                  <span v-if="display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).visibility" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).title }}</strong></span>
                  <v-icon @click="display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).visibility = !display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).visibility; updateCRMRealTimeEventsHeadersVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).visibility ? 'eye' : 'eye-off' }}</v-icon>
                </template>
                <v-icon v-if="display.CRMRealTimeEventsHeaders.find(header => header.value == column.key).index < display.CRMRealTimeEventsHeaders.length - 1" @click="updateCRMRealTimeEventsHeadersIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>  
              </template>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          </th>
        </tr>
      </template>
      <template v-slot:item="row">
        <tr :class="row.item.loadingCRMRealTimeEvent ? 'loadingVDataTableRow' : (row.item.appearingCRMRealTimeEvent ? 'appearingVDataTableRow' : (row.item.selectedCRMRealTimeEvent ? 'selectedVDataTableRow' : (loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentPagination ? 'loadingVDataTableRow' : null)))">
          <template v-for="header in display.CRMRealTimeEventsHeaders.sort((a, b) => a.index - b.index)" :key="header.value">
            <td :class="header.value != 'CRMRealTimeEventSelectAction' && computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent ? 'bluredVDataTableRow' : null">
              <template v-if="header.value == 'CRMRealTimeEventID' && header.visibility">
                <v-hover>
                  <template v-slot="{ isHovering, hoverProps }">
                    <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                      <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                        <template v-slot:activator="{ props: tooltipProps }">
                          <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del evento', 'o', row.item.CRMRealTimeEventID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventID }}</strong></p>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del evento', 'o', row.item.CRMRealTimeEventID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventID }}</strong></p>
                    </template>
                  </template>
                </v-hover>
              </template>
              <template v-if="header.value == 'CRMRealTimeEventCreationCRMAgentID' && header.visibility">
                <template v-if="row.item.CRMRealTimeEventCreationCRMAgentID && systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMRealTimeEventCreationCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMRealTimeEventCreationCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMRealTimeEventCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMRealTimeEventCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </template>
              <template v-if="header.value == 'CRMRealTimeEventCreationDatetime' && header.visibility">
                <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMRealTimeEventCreationDatetime) }}</p>
              </template>
              <template v-if="header.value == 'CRMRealTimeEventType' && header.visibility">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <v-icon :color="display.CRMRealTimeEventTypes[row.item.CRMRealTimeEventType] ? display.CRMRealTimeEventTypes[row.item.CRMRealTimeEventType].color : 'primary'" class="hoverableElement">{{ display.CRMRealTimeEventTypes[row.item.CRMRealTimeEventType] ? display.CRMRealTimeEventTypes[row.item.CRMRealTimeEventType].icon : 'mdi-tag' }}</v-icon>
                  <template v-if="row.item.CRMRealTimeEventType == 'closeCRMWhatsappConversation'">
                    <p>Ha cerrado la conversación <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappConversationID }}</strong></span> con <span style="color: #3F51B5;"><strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMRealTimeEventData.CRMWhatsappConversationPhoneNumber, false) }}</strong></span> como <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappConversationResult }}</strong></span></p>
                  </template>
                  <template v-if="row.item.CRMRealTimeEventType == 'generateCRMWhatsappInvoice'">
                    <p>Ha generado la orden <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</strong></span> para la conversación <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMWhatsappConversationID }}</strong></span> en la localidad</p>
                    <v-template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID)">
                      <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                        <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                        <div v-if="row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityMapDivisionID" style="display: flex; align-items: center;">
                          <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                          <p style="font-size: x-small;">{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityID)?.CRMLocalityMap?.CRMLocalityMapDivisions?.find(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID == row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMLocalityMapDivisionID)?.CRMLocalityMapDivisionName || 'No registrada' }}</p>
                        </div>
                      </v-chip>
                    </v-template>
                    <template v-else>
                      <v-chip color="primary" variant="flat" elevation="2" label>
                        <p>No registrada</p>
                      </v-chip>
                    </template>
                  </template>
                  <template v-if="row.item.CRMRealTimeEventType == 'cancelCRMWhatsappInvoice'">
                    <p>Ha cancelado la orden <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</strong></span></p>
                  </template>
                  <template v-if="row.item.CRMRealTimeEventType == 'confirmSINPEPayment'">
                    <p>Ha confirmado el pago por SINPE para la {{ row.item.CRMRealTimeEventData.CRMWhatsappConversationID ? 'conversación' : 'orden'}} <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappConversationID || row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</strong></span></p>
                  </template>
                  <template v-if="row.item.CRMRealTimeEventType == 'confirmSINPEPaymentByCRMToken'">
                    <p>Ha confirmado el pago por SINPE para la {{ row.item.CRMRealTimeEventData.CRMWhatsappConversationID ? 'conversación' : 'orden'}} <span style="color: #3F51B5;"><strong>{{ row.item.CRMRealTimeEventData.CRMWhatsappConversationID || row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID }}</strong></span> mediante token</p>
                  </template>
                </div>
              </template>
              <template v-if="header.value == 'CRMRealTimeEventAction' && header.visibility">
                <template v-if="row.item.CRMRealTimeEventType == 'closeCRMWhatsappConversation'">
                  <v-btn 
                    @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMRealTimeEventData.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
                    :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                    color="primary" 
                    class="hoverableText"
                  >
                    <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                    <p style="font-size: small;">CONVERSACIÓN</p>
                  </v-btn>
                </template>
                <template v-if="row.item.CRMRealTimeEventType == 'generateCRMWhatsappInvoice'">
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <v-btn 
                      @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMRealTimeEventData.CRMWhatsappInvoiceCRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
                      :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                      color="primary" 
                      class="hoverableText"
                    >
                      <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                      <p style="font-size: small;">CONVERSACIÓN</p>
                    </v-btn>
                    <v-btn 
                      @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
                      :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                      color="primary" 
                      class="hoverableText"
                    >
                      <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                      <p style="font-size: small;">ORDEN</p>
                    </v-btn>
                  </div>
                </template>
                <template v-if="row.item.CRMRealTimeEventType == 'cancelCRMWhatsappInvoice'">
                  <v-btn 
                    @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
                    :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                    color="primary" 
                    class="hoverableText"
                  >
                    <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                    <p style="font-size: small;">ORDEN</p>
                  </v-btn>
                </template>
                <template v-if="row.item.CRMRealTimeEventType == 'confirmSINPEPayment' || row.item.CRMRealTimeEventType == 'confirmSINPEPaymentByCRMToken'">
                  <template v-if="row.item.CRMRealTimeEventData.CRMWhatsappConversationID">
                    <v-btn 
                      @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMRealTimeEventData.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
                      :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                      color="primary" 
                      class="hoverableText"
                    >
                      <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                      <p style="font-size: small;">CONVERSACIÓN</p>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn 
                      @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([row.item.CRMRealTimeEventData.CRMWhatsappInvoiceID])" 
                      :disabled="row.item.loadingCRMRealTimeEvent || row.item.appearingCRMRealTimeEvent || (computed_selectedCRMRealTimeEventsCount > 0 && !row.item.selectedCRMRealTimeEvent)"
                      color="primary" 
                      class="hoverableText"
                    >
                      <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                      <p style="font-size: small;">ORDEN</p>
                    </v-btn>
                  </template>
                </template>
              </template>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:loading>
        <div style="">

        </div>
      </template>
      <template v-slot:bottom></template>
    </v-data-table>
    <template v-if="display.CRMRealTimeEventsCount > 0">
      <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
      <v-card elevation="0" rounded="0" color="primary">
        <div class="footerContainer">
          <div class="footerActionsContainer">
            <template v-if="computed_selectedCRMRealTimeEventsCount > 0">
              <p><strong>{{ computed_selectedCRMRealTimeEventsCount }}</strong> evento{{ computed_selectedCRMRealTimeEventsCount > 1 ? 's' : '' }} seleccionado{{ computed_selectedCRMRealTimeEventsCount > 1 ? 's' : '' }}</p>
              <v-btn color="indigo" class="hoverableText" @click="updateCRMRealTimeEventsUpdateDatetime(computed_selectedCRMRealTimeEventsCount > 0 ? null : row.item)">
                <v-icon size="small" style="margin-right: 10px;">mdi-check-circle</v-icon>
                <p style="font-size: small;">MARCAR COMO VISTO{{ (computed_selectedCRMRealTimeEventsCount > 1) ? 'S' : '' }}</p>
              </v-btn>
              <v-btn color="error" class="hoverableText" @click="display.CRMRealTimeEvents.forEach(CRMRealTimeEvent => CRMRealTimeEvent.selectedCRMRealTimeEvent = false); input.allCRMRealTimeEventsSelected = false;">
                <v-icon size="small" style="margin-right: 10px;">mdi-close-circle</v-icon>
                <p style="font-size: small;">CANCELAR</p>
              </v-btn>
            </template>
          </div>
          <div class="footerPaginatorContainer">
            <v-pagination
              v-model="input.page"
              @update:model-value="selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent(false)"
              :disabled="loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentPagination"
              :length="Math.ceil(display.CRMRealTimeEventsCount / navigation.limit)"
              :total-visible="5"
              density="compact"
              size="small"
            ></v-pagination>
            <p style="font-size: x-small;">{{ (display.CRMRealTimeEventsCount == 0) ? `0 de 0 eventos` : `${(input.page - 1) * navigation.limit + 1} - ${Math.min(input.page * navigation.limit, display.CRMRealTimeEventsCount)} de ${display.CRMRealTimeEventsCount} ${display.CRMRealTimeEventsCount > 1 ? 'eventos' : 'evento'}`}}</p>
          </div>
        </div>
      </v-card>
    </template>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }
  .footerContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;
    padding: 10px;
  }
  .footerActionsContainer {
    display: flex;
    flex-direction: row;
    margin-right: auto;
    gap: 15px;
    align-items: center;
  }
  .footerPaginatorContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: auto;
  }
  @media (max-width: 1200px) {
    .footerContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .footerActionsContainer {
      margin-right: 0;
      flex-direction: column;
    }
    .footerPaginatorContainer {
      margin-left: 0;
    }
  }
  
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => ({
      input: 
      {
        allCRMRealTimeEventsSelected: false,
        page: 1
      },
      display: 
      {
        CRMRealTimeEventsHeaders:
        [
          {title: 'ID', value: 'CRMRealTimeEventID', icon: 'mdi-barcode', index: 1, visibility: true},
          {title: 'AGENTE', value: 'CRMRealTimeEventCreationCRMAgentID', icon: 'mdi-account', index: 2, visibility: true},
          {title: 'FECHA', value: 'CRMRealTimeEventCreationDatetime', icon: 'mdi-calendar', index: 3, visibility: true},
          {title: 'EVENTO', value: 'CRMRealTimeEventType', icon: 'mdi-tag', index: 4, visibility: true},
          {title: 'ACCIÓN', value: 'CRMRealTimeEventAction', icon: 'mdi-card', index: 5, visibility: true}
        ],
        CRMRealTimeEvents: [],
        CRMRealTimeEventsCount: 0,

        CRMRealTimeEventTypes:
        {
          'closeCRMWhatsappConversation': {'color': 'primary', 'icon': 'mdi-chat-remove', 'title': 'Cierre de conversación'},
          'generateCRMWhatsappInvoice': {'color': 'success', 'icon': 'mdi-invoice-text-plus', 'title': 'Generación de orden'},
          'cancelCRMWhatsappInvoice': {'color': 'error', 'icon': 'mdi-invoice-text-remove', 'title': 'Cancelación de orden'},
          'confirmSINPEPayment': {'color': 'info', 'icon': 'mdi-cash-check', 'title': 'Confirmación de pago por SINPE'},
          'confirmSINPEPaymentByCRMToken': {'color': 'info', 'icon': 'mdi-cash-check', 'title': 'Confirmación de pago por SINPE mediante token'}
        }
      },
      navigation:
      {
        limit: 300,
        noData: false
      },
      loader:
      {
        getSystemInformationData: false,
        selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent: false,
        selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentPagination: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed: 
    {
      computed_selectedCRMRealTimeEventsCount(){
        return this.display.CRMRealTimeEvents.slice().filter(CRMRealTimeEvent => CRMRealTimeEvent.selectedCRMRealTimeEvent).length;
      }
    },

    methods: 
    {
      async selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent(isNewSearch){
        if (isNewSearch){
          this.input.page = 1;
          this.display.CRMRealTimeEvents.length = 0;
          this.display.CRMRealTimeEventsCount = 0;
          this.loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent = true;
        }
        this.loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentPagination = true;
        const selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'page': this.input.page,
          'limit': this.navigation.limit
        };
        const selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMRealTimeEvent/functions/selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent', selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentRequestQuery);
        if (selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentResult.success) {
          this.display.CRMRealTimeEvents = selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentResult.result.CRMRealTimeEvents.map(CRMRealTimeEvent => ({
            ...CRMRealTimeEvent,
            'selectedCRMRealTimeEvent': false,
            'loadingCRMRealTimeEvent': false,
            'appearingCRMRealTimeEvent': false
          }));
          this.display.CRMRealTimeEventsCount = selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentResult.result.CRMRealTimeEventsCount;
          this.navigation.noData = this.display.CRMRealTimeEventsCount == 0;
          this.loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent = false;
          this.loader.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponentPagination = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent_error', 'error', 'Ha ocurrido un error inesperado al consultar los eventos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      updateCRMRealTimeEventsHeadersIndex(headerKey, indexChange) {
        const updatedTableHeader = this.display.CRMRealTimeEventsHeaders.find(header => header.value == headerKey);
        const swappedTableHeader = this.display.CRMRealTimeEventsHeaders.find(header => header.index == (this.display.CRMRealTimeEventsHeaders.find(header => header.value == headerKey).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        const headers = this.display.CRMRealTimeEventsHeaders.reduce((headers, header) => {headers[header.value] = header.index; return headers;}, {});
        localStorage.setItem('CRMDashboardCRMRealTimeEventsView_CRMRealTimeEventsHeaders', JSON.stringify(headers));      
      },
      updateCRMRealTimeEventsHeadersVisibility(){
        localStorage.setItem('CRMDashboardCRMRealTimeEventsView_CRMRealTimeEventsHeaders', JSON.stringify(this.display.CRMRealTimeEventsHeaders));      
      },
      async prepareTable() {
        let headersVisibility;
        try { headersVisibility = JSON.parse(localStorage.getItem('CRMDashboardCRMRealTimeEventsView_CRMRealTimeEventsHeaders')); }
        catch { headersVisibility = null; }
        for (const headerIndex in headersVisibility){
          const headerVisibility = headersVisibility[headerIndex];
          if (this.display.CRMRealTimeEventsHeaders.find(header => header.index == headerIndex)) this.display.CRMRealTimeEventsHeaders.find(header => header.index == headerIndex).visibility = headerVisibility.visibility 
        }
        let headersIndex;
        try { headersIndex = JSON.parse(localStorage.getItem('CRMDashboardCRMRealTimeEventsView_CRMRealTimeEventsHeaders')); }
        catch { headersIndex = null; }
        this.display.CRMRealTimeEventsHeaders = this.display.CRMRealTimeEventsHeaders.map(header => ({ ...header, index: headersIndex?.[header.value] ?? Infinity })).sort((headerA, headerB) => headerA.index - headerB.index).map((header, i) => ({ ...header, index: i }));
        this.loader.getSystemInformationData = false;
      },
      async getSystemInformationData(){
        try {
          this.loader.getSystemInformationData = true;
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },  

    async mounted() {
      await this.getSystemInformationData();
      await this.prepareTable();
      this.selectCRMRealTimeEventsFromCRMDashboardCRMRealTimeEventsComponent(true);
    }
  }
</script>